<div [innerHTML]="displayedText"></div>
